import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AppProvider, useApp } from './store/AppContext.js';
import { Layout } from './components/Layout.js';
import { Landing } from './pages/Landing.js';
import { Login } from './pages/Login.js';
import { Register } from './pages/Register.js';
import { VerifyEmail } from './pages/VerifyEmail.js';
import { Unlock } from './pages/Unlock.js';
import { Vault } from './pages/Vault.js';
import { PasswordGeneratorPage } from './pages/PasswordGenerator.js';
import { SecurityDashboard } from './pages/SecurityDashboard.js';
import { SharingPage } from './pages/Sharing.js';
import { OrgSettings } from './pages/OrgSettings.js';
import { AuditLogsPage } from './pages/AuditLogs.js';
import { AccountSettings } from './pages/AccountSettings.js';
import { MfaSetup } from './pages/MfaSetup.js';

function Loading() {
  return (
    <div className="auth-wrap">
      <div className="panel center" style={{ padding: 32 }}>
        <div className="mono muted">Loading vault…</div>
      </div>
    </div>
  );
}

function Router() {
  const { status } = useApp();
  const loc = useLocation();

  if (status === 'loading') return <Loading />;

  // Guests see public pages only.
  if (status === 'guest') {
    return (
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/reset-password" element={<VerifyEmail mode="reset" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  // Authenticated but locked: only the unlock screen (and logout).
  if (status === 'locked') {
    return (
      <Routes>
        <Route path="/unlock" element={<Unlock />} />
        <Route path="*" element={<Navigate to="/unlock" replace />} />
      </Routes>
    );
  }

  // Unlocked: the full app. Guard against landing on auth pages.
  if (loc.pathname === '/' || loc.pathname.startsWith('/login') || loc.pathname.startsWith('/register') || loc.pathname.startsWith('/unlock')) {
    return <Navigate to="/vault" replace />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/vault" element={<Vault />} />
        <Route path="/vault/trash" element={<Vault trash />} />
        <Route path="/generator" element={<PasswordGeneratorPage />} />
        <Route path="/security" element={<SecurityDashboard />} />
        <Route path="/sharing" element={<SharingPage />} />
        <Route path="/orgs" element={<OrgSettings />} />
        <Route path="/audit" element={<AuditLogsPage />} />
        <Route path="/settings" element={<AccountSettings />} />
        <Route path="/settings/mfa" element={<MfaSetup />} />
        <Route path="*" element={<Navigate to="/vault" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <AppProvider>
      <Router />
    </AppProvider>
  );
}
